import { uiSize } from '@utils'

function InfoIcon() {
  return (
    <svg width={uiSize(20)} height={uiSize(21)} viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='10' cy='10.5896' r='10' fill='var(--banky-royal-blue)' />
      <path
        d='M10.748 5.63647L10.584 12.657H9.17578L9.00488 5.63647H10.748ZM8.95703 14.8103C8.95703 14.5597 9.03906 14.35 9.20312 14.1814C9.37174 14.0082 9.60417 13.9216 9.90039 13.9216C10.1921 13.9216 10.4222 14.0082 10.5908 14.1814C10.7594 14.35 10.8438 14.5597 10.8438 14.8103C10.8438 15.0518 10.7594 15.2592 10.5908 15.4324C10.4222 15.601 10.1921 15.6853 9.90039 15.6853C9.60417 15.6853 9.37174 15.601 9.20312 15.4324C9.03906 15.2592 8.95703 15.0518 8.95703 14.8103Z'
        fill='var(--banky-white)'
      />
    </svg>
  )
}

export default InfoIcon
